<template>
  <a-card :bordered="false">
    <div>
      <div class="table-page-search-wrapper">
        <a-form layout="inline" @keyup.enter.native="getMessageList">
          <a-row :gutter="24">
            <a-col :md="6" :sm="12">
              <a-form-item label="接收人">
                <a-input placeholder="请输入" v-model="searchUsers"></a-input>
              </a-form-item>
            </a-col>

            <a-col :md="4" :sm="10">
              <span
                style="float: right; overflow: hidden"
                class="table-page-search-submitButtons"
              >
                <a-button
                  type="primary"
                  @click="getMessageList"
                  icon="search"
                  style="margin-right: 8px"
                  >查询</a-button
                >
                <a-button type="primary" @click="searchReset" icon="reload"
                  >重置</a-button
                >
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <div class="table-operator" style="line-height: 40px">
        <a-button @click="handleAdd" type="primary" icon="plus"
          >新增消息</a-button
        >
      </div>
      <a-drawer
        title="新增消息"
        :placement="placement"
        :closable="false"
        :visible="visibleAdd"
        @close="closeAddVisible"
        width="550px"
      >
        <a-form-model
          ref="ruleForm"
          :model="form"
          :rules="rules"
          :label-col="labelCol"
          :wrapper-col="wrapperCol"
        >
          <a-form-model-item
            ref="textcard.title"
            label="标题"
            prop="textcard.title"
          >
            <a-input v-model="form.textcard.title" />
          </a-form-model-item>
          <a-form-model-item ref="touser" label="接收人" prop="touser">
            <a-tree-select
              show-search
              tree-checkable
              style="width: 100%"
              v-model="hasChoose"
              :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
              placeholder="请选择"
              :tree-data="personTree"
              multiple
              allow-clear
              tree-default-expand-all
              treeNodeFilterProp="title"
              @change="choose"
            >
            </a-tree-select>
          </a-form-model-item>
          <a-form-model-item label="发送时间" required prop="time">
            <a-date-picker
              format="YYYY-MM-DD HH:mm"
              @change="onChange"
              show-time
              type="date"
              placeholder="请选择"
              style="width: 100%"
            />
          </a-form-model-item>
          <a-form-model-item label="应用名称" prop="agentid">
            <a-select
              option-filter-prop="children"
              v-model="form.agentid"
              placeholder="请选择"
              show-search
              @search="handleSearch"
            >
              <a-select-option
                :value="item.agentId"
                v-for="(item, index) in nameTypeList"
                :key="index"
              >
                {{ item.agentName }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item
            label="发送内容"
            required
            prop="textcard.description"
          >
            <a-input v-model="form.textcard.description" type="textarea" />
            <!-- <p @click="contentDia=true" style="color:#1890FF">点击编辑内容</p> -->
          </a-form-model-item>
          <a-form-model-item :wrapper-col="{ span: 14, offset: 4 }">
            <a-button type="primary" @click="onSubmitMessage"> 确定 </a-button>
            <a-button style="margin-left: 10px" @click="resetForm">
              取消
            </a-button>
          </a-form-model-item>
        </a-form-model>
      </a-drawer>
      <a-table :columns="columns" :data-source="messageData" bordered>
        <a
          slot="action"
          slot-scope="record"
          href="javascript:;"
          @click="showDetails(record.id)"
          >详情</a
        >
      </a-table>
      <a-modal
        title="发送内容"
        :visible="visible"
        @ok="visible = false"
        @cancel="visible = false"
      >
        <p>
          <span style="color: #333333">标题：</span
          ><em v-if="detailsInfo.textcard">{{ detailsInfo.textcard.title }}</em>
        </p>
        <p>
          <span style="color: #333333">接收人：</span
          >{{ detailsInfo.userNames }}
        </p>
        <p>
          <span style="color: #333333">发送时间：</span
          ><em v-if="detailsInfo.sendTime == null">2021-08-21 08:00:00</em
          ><em v-else>{{ detailsInfo.sendTime }}</em>
        </p>
        <p><span style="color: #333333">应用名称：</span>晨会报告</p>
        <div>
          <label for="" style="color: #333333">内容：</label>
          <a-textarea
            v-if="detailsInfo.textcard"
            v-model="detailsInfo.textcard.description"
            :rows="4"
            disabled
          />
        </div>
      </a-modal>
      <!-- 编辑内容 -->
      <a-modal
        title="发送内容"
        :visible="contentDia"
        width="750px"
        @ok="contentDia = false"
        @cancel="contentDia = false"
      >
        <!-- 富文本编辑器 -->
        <!-- <div class="content">
          <tinymce-editor ref="tinymceEditor" :value="form.textcard.description" @change="getMyValue" />
        </div> -->
      </a-modal>
    </div>
  </a-card>
</template>
<script>
import { loop } from '@/utils/common';
import {
  baseNameList,
  messageList,
  getCusAll,
  submitMessage,
  messageDetail
} from '@/api/api';
// import tinymceEditor from '@/components/tools/tinymceEditor';

const columns = [
  { title: '标题', dataIndex: 'title', key: '1' },
  { title: '接收人', dataIndex: 'touser', key: '3' },
  { title: '发送时间', dataIndex: 'time', key: '2' },
  { title: '应用名称', dataIndex: 'name', key: '4' },
  {
    title: '操作',
    key: 'operation',
    scopedSlots: { customRender: 'action' }
  }
];
const messageData = [];
export default {
  data() {
    return {
      detailsInfo: {},
      searchUsers: '',
      hasChoose: undefined,
      contentDia: false,
      personTree: [],
      value: undefined,
      messageData,
      nameTypeList: [],
      columns,
      visibleAdd: false,
      placement: 'right',
      visible: false,
      queryParam: {},
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      other: '',
      form: {
        userNames: '',
        touser: undefined,
        time: '',
        agentid: '',
        msgtype: 'textcard',
        textcard: {
          title: '',
          description: '',
          url: 'https://www.baidu.com'
        }
      },
      rules: {
        agentid: [
          { required: true, message: '请选择应用名称', trigger: 'change' }
        ],
        time: [
          { required: true, message: '请选择发送时间', trigger: 'change' }
        ],
        textcard: {
          description: [
            { required: true, message: '请填写发送内容', trigger: 'change' }
          ],
          title: [{ required: true, message: '请填写标题', trigger: 'blur' }]
        },
        touser: [{ required: true, message: '请选择接收人', trigger: 'change' }]
      }
    };
  },

  components: {
    tinymceEditor
  },
  created() {
    this.getMessageList();
    this.getNameList();
    this.choosePeople();
  },
  methods: {
    //获取消息列表
    getMessageList() {
      let users = this.searchUsers;
      messageList({ users }).then(res => {
        if (res) {
          // this.messageData = []
          const list = res.result.list.map((item, index) => {
            return {
              key: item.id,
              touser: item.userNames,
              time: item.sendTime || '2021-08-21 08:00:00',
              id: item.id,
              title: item.textcard.title,
              name: item.agentName || '晨会报告'
            };
          });
          this.messageData = list;
        }
      });
    },
    //选择人员
    choosePeople() {
      getCusAll().then(res => {
        // console.log(res, '获取树结构');
        if (res.success) {
          // this.personTree = res.result
          // 递归循环

          this.personTree = loop(res.result);
          console.log(this.personTree);
        }
      });
    },
    //富文本
    getMyValue(val) {
      this.form.textcard.description = val;
      console.log(val);
    },
    handleSearch(value) {
      console.log(value);
    },
    //提交新增消息
    onSubmitMessage() {
      let params = this.form;
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          submitMessage(params).then(res => {
            if (res) {
              this.$message.success('新增消息成功');
              this.visibleAdd = false;
              this.getMessageList();
            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    choose(value, label, extra) {
      // console.log('222',value, value[0])
      this.hasChoose = value;
      let newValue = [];
      value.map(item => {
        newValue.push(item.substring(0, item.lastIndexOf('_')));
      });
      console.log(newValue);
      this.form.touser = newValue.join('|');
      this.form.userNames = label.join(',');
    },
    onChange(val) {
      // val._d.replace('T',' ')
      console.log(val._d);
      this.form.time = val._d;
    },
    showDetails(ids) {
      this.visible = true;
      let id = ids;
      messageDetail({ id }).then(res => {
        console.log(res);
        this.detailsInfo = res.result;
      });
    },
    onClose() {
      this.visible = false;
    },
    //重置
    searchReset() {
      this.searchUsers = '';
      this.getMessageList();
    },
    handleAdd() {
      this.visibleAdd = true;
    },
    closeAddVisible() {
      this.visibleAdd = false;
    },

    resetForm() {
      this.$refs.ruleForm.resetFields();
      this.visibleAdd = false;
    },
    //应用名称下拉框
    getNameList(value) {
      let name = '';
      if (value) {
        name = value;
      } else {
        name = '';
      }
      baseNameList({ name }).then(res => {
        if (res) {
          this.nameTypeList = res.result;
        }
        // if (res.success) {

        // }
      });
    }
  }
};
</script>
